import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=e71e2a78&scoped=true"
import script from "./DialogWrapper.vue?vue&type=script&lang=js"
export * from "./DialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=e71e2a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71e2a78",
  null
  
)

export default component.exports